import React from "react";
import { Link } from 'react-router-dom';

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import UserInfo from "./SignupSteps/UserInfo.jsx";
import Options from "./SignupSteps/Options.jsx";
import Address from "./SignupSteps/Address.jsx";
import Payment from "./SignupSteps/Payment.jsx";
import Agreement from "./SignupSteps/Agreement.jsx";
import SubmitAgreement from "./SignupSteps/SubmitAgreement.jsx";

import withStyles from "@material-ui/core/styles/withStyles";


import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class SignupView extends React.Component {
  constructor(props) {
    super(props);
    var showPreLoginHeaderAndFooter = true;
    var wizardWidth = ''
    if (props.showPreLoginHeaderAndFooter || props.showPreLoginHeaderAndFooter === false) {
      showPreLoginHeaderAndFooter = props.showPreLoginHeaderAndFooter
    }
    if (props.wizardWidth) {
      wizardWidth = props.wizardWidth
    }
    this.state = {
      showPreLoginHeaderAndFooter: showPreLoginHeaderAndFooter,
      wizardWidth: wizardWidth
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <span style={this.state.showPreLoginHeaderAndFooter ? {} : { display: 'none' }}>
          <PreLoginHeader />
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={12}>
              <div style={{textAlign: 'center'}}>
                Already have an account? <Link className={classes.linkClass} to="/login">Log in here.</Link>
              </div>
            </GridItem>
          </GridContainer>
        </span>
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={8}  style={{width: this.state.wizardWidth}}>
            <Wizard
              validate
              steps={[
                { stepName: "account info", stepComponent: UserInfo, stepId: "userInfo" },
                { stepName: "address", stepComponent: Address, stepId: "address" },
                { stepName: "options", stepComponent: Options, stepId: "options" },
                { stepName: "review terms", stepComponent: Agreement, stepId: "agreement" },
                { stepName: "deposit info", stepComponent: Payment, stepId: "payment" },
                { stepName: "submit", stepComponent: SubmitAgreement, stepId: "submitAgreement" }
              ]}
              title="Set up your account"
              subtitle="This information will get you set up and ready for care."
            />
          </GridItem>
        </GridContainer>
        <span style={this.state.showPreLoginHeaderAndFooter ? {} : { display: 'none' }}>
          <Footer fluid />
        </span>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(SignupView);
